import { createSlice } from "@reduxjs/toolkit";
import { cancelOrderThunk, fetchOrdersThunk, submitPickupRequestThunk } from "./ordersThunk";
import { updateAffiliateOrderThunk } from "../affiliate-orders/affiliateOrdersThunk";

const initialState = {
    items: [],
    total: 0,
    totalPages: 0,
    loading: false,
    hasMore: true,
    error: null,
    page: 1
};

export const ordersSlice = createSlice({
    name: "orders",
    initialState,
    reducers: {
        setInitialData: (state, action) => {
            const { items, hasMore, total, totalPages } = action.payload;
            state.items = items;
            state.total = total;
            state.totalPages = totalPages;
            state.hasMore = hasMore;
        },
        removeItem: (state, action) => {
            const id = action.payload;
            state.items = state.items.filter((e) => e.id !== id);
            state.total = state.total - 1;
        },
        resetOrders: (state) => {
            state.items = [];
            state.total = 0;
            state.totalPages = 0;
            state.page = 1;
            state.hasMore = true;
            state.error = null;
        },
        setPage: (state, action) => {
            state.page = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchOrdersThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchOrdersThunk.fulfilled, (state, action) => {
                state.loading = false;
                const data = action.payload;
                const orders = data.content;
                state.items = orders;
                state.total = data.totalElements;
                state.totalPages = data.totalPages;
                state.hasMore = !data.last;
            })
            .addCase(fetchOrdersThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(cancelOrderThunk.fulfilled, (state, action) => {
                const { orderId, newStatus } = action.payload;
                state.items = state.items.map((item) => {
                    if (item.id === orderId) {
                        return { ...item, orderStatus: newStatus };
                    }
                    return item;
                });
            })

            .addCase(updateAffiliateOrderThunk.fulfilled, (state, action) => {
                const { orderId, ...updatedAffiliateOrderData } = action.payload;
                const index = state.items.findIndex((e) => Number(e.id) === Number(orderId));
                if (index !== -1) {
                    state.items[index] = {
                        ...state.items[index],
                        affiliateOrderData: {
                            ...state.items[index].affiliateOrderData,
                            ...updatedAffiliateOrderData
                        }
                    };
                }
            })

            .addCase(submitPickupRequestThunk.fulfilled, (state, action) => {
                const { id, pickupRequestCode } = action.payload;
                state.items = state.items.map((item) =>
                    item.id === id
                        ? { ...item, orderStatus: "Pickup_Requested", pickupRequestCode }
                        : item
                );
            });
    }
});

export const { setInitialData, resetOrders, removeItem, setPage } = ordersSlice.actions;
export default ordersSlice.reducer;
